export const AssignmentCode = {
    /** 배송조회 */
    TRACK_DELIVERY: 'trackDelivery',
    /** 취소요청 */
    REQUEST_CANCEL: 'requestCancel',
    /** 취소정보 */
    CANCEL_INFO: 'cancelInfo',
    /** 반품요청 */
    REQUEST_REFUND: 'requestRefund',
    /** 반품정보 */
    REFUND_INFO: 'refundInfo',
    /** 반품철회 */
    WITHDRAW_REFUND: 'withdrawRefund',
    /** 교환요청 */
    REQUEST_EXCHANGE: 'requestExchange',
    /** 교환정보 */
    EXCHANGE_INFO: 'exchangeInfo',
    /**
     * 교환정보 (이전 교환정보)
     * EXCHANGE_INFO 와 동일하지만, 2차 클레임 상태(교환->반품) 일 때 해당 이름으로 내려온다.
     */
    EXCHANGE_INFO_BEFORE: 'exchangeInfoBefore',
    /** 교환철회 */
    WITHDRAW_EXCHANGE: 'withdrawExchange',
    /** 반송조회 */
    TRACK_RETURN_DELIVERY: 'trackReturnDelivery',
    /** 재배송조회 */
    TRACK_REDELIVERY: 'trackRedelivery',
    /** 구매확정연장 */
    EXTEND_PURCHASE_DECISION: 'extendPurchaseDecision',
    /** 구매확정 */
    CONFIRM_PURCHASE: 'confirmPurchase',
    /** 선물하기 */
    GIFTING: 'gifting',
    /** 재구매 */
    ORDER_REPURCHASE: 'orderRepurchase',
    /** 정기구독재신청 */
    RESUBSCRIPTION: 'resubscription',
    /** 리뷰쓰기 */
    WRITE_REVIEW: 'writeReview',
    /** 한달사용리뷰 */
    WRITE_AFTER_USE_REVIEW: 'writeAfterUseReview',
    /** e쿠폰정보 */
    ECOUPON_INFO: 'ecouponInfo',
    /** 결제하기 */
    FAMILY_PAY: 'familyPay',
    /** 결제거절 */
    FAMILY_PAY_REJECT: 'familyPayReject',
    /** 주문상세 */
    ORDER_DETAIL: 'orderDetail',
    /** 배송지변경 */
    CHANGE_DESTINATION: 'changeDestination',
    /** 영수증조회 */
    GET_RECEIPT: 'getReceipt',
    /** 발송지연사유 */
    DELAY_REASON: 'delayReason',
    /** 반품비용결제 */
    PAY_REFUND_CHARGE: 'payRefundCharge',
    /** 교환비용결제 */
    PAY_EXCHANGE_CHARGE: 'payExchangeCharge',
    /** 플리마켓리뷰 */
    WRITE_FLEA_MARKET_REVIEW: 'writeFleaMarketReview',
} as const

export type AssignmentCodeValues = Constant<typeof AssignmentCode>

export const FirstPriorityAssignments = [
    AssignmentCode.CONFIRM_PURCHASE,
    AssignmentCode.WRITE_REVIEW,
    AssignmentCode.WRITE_AFTER_USE_REVIEW,
]

export const SecondPriorityAssignments = [
    AssignmentCode.TRACK_DELIVERY,
    AssignmentCode.PAY_EXCHANGE_CHARGE,
    AssignmentCode.PAY_REFUND_CHARGE,
    AssignmentCode.TRACK_REDELIVERY,
    AssignmentCode.TRACK_RETURN_DELIVERY,
    AssignmentCode.RESUBSCRIPTION,
    AssignmentCode.WRITE_FLEA_MARKET_REVIEW,
]

export const ExposedRewardAssignmentButton = {
    /** 구매확정 */
    ConfirmPurchase: 'confirmPurchase',
    /** 리뷰쓰기 */
    WriteReview: 'writeReview',
    /** 한달리뷰쓰기 */
    WriteAfterUseReview: 'writeAfterUseReview',
}

export const AssignmentButton = {
    PRIORITY: 'PRIORITY',
    SECOND: 'SECOND',
    EXPOSED_REWARD: 'EXPOSED_REWARD',
    NONE: 'NONE',
} as const

export type AssignmentButtonType = Constant<typeof AssignmentButton>
